import React, {useState} from 'react';
import TextInput from '../../../Shared/TextInput/TextInput';
import Footer from '../Assets/footer';
import Image from 'app/Components/Shared/Image/image';
import {LogoHelper, LogoType} from 'app/utilities/LogoHelper/helper';
import {validateInput, TextInputEnum, InputValidation} from '../../../../utilities/validation/InputValidation';
import { isMobile } from 'react-device-detect';
import { isNullOrEmpty } from 'app/utilities/StringHelpers/StringHelpers';

const GenericParamsInsert = (props) => {
  const fields = props.genericData.fields || [];
  const [formValues, setFormValues] = useState(() =>
    fields.reduce((acc, field) => {
      acc[field.name] = '';
      return acc;
    }, {}),
  );
  const [errors, setErrors] = useState({});
  const mainLogo = LogoHelper.getLogo(LogoType.MainLogo);

  const handleChange = (field, value) => {
    setFormValues((prev) => ({...prev, [field.name]: value}));
    setErrors((prev) => {
      const next = {...prev};
      delete next[field.name];
      return next;
    });
  };
  
  const validateForm = () => {
    const nextErrors = {};
    fields.forEach((field) => {
      const error = validateInput(formValues[field.name] || '', field.type);
      if (error) {
        nextErrors[field.name] = error;
      }
    });
    setErrors(nextErrors);
    if(Object.keys(nextErrors).length === 0){
      props.setGenericValues(formValues);
    }
    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    props.onclick(formValues);
  };

  const renderIcon = () => {
    if (props.templateIcon != null && props.templateIcon != '') {
      return <Image src={props.templateIcon} alt='icon' className='iconTop' />;
    }
    return <Image className='iconTop' src={mainLogo} alt='main logo' />;
  };

  var title = !isNullOrEmpty(props.specialTitle) ? props.specialTitle : props.genericData.title;
  var secondaryText = !isNullOrEmpty(props.specialText) ? props.specialText : props.genericData.secondaryText;


  return (
    <div className='screenContainer'>
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          await handleSubmit();
        }}>
        {renderIcon()}
        <h3 className={`heading ${props.secondaryText ? 'withSecondary' : ''}`}>
            {title}
        </h3>
        {!isNullOrEmpty(secondaryText)  && <h3 className='secondaryHeading'>{secondaryText}</h3>}

        {fields.map((field) => (
          <TextInput
            key={field.name}
            name={field.name}
            placeholder={field.placeholder}
            value={formValues[field.name] || ''}
            maxLength={field.maxLength}
            type='text'
            inputMode={field.isNumeric ? 'numeric' : undefined}
            error={errors[field.name]}
            onChange={(e) => handleChange(field, e.target.value)}
          />
        ))}

        {props.isReset && (
          <div className='more-info'>הקוד שקיבלתם כבר לא בתוקף. כדי לשמור על הפרטים שלכם, נתחיל את התהליך מחדש</div>
        )}
        <Footer onclick={() => {}} stage={props.stage} />
      </form>
    </div>
  );
};

export default GenericParamsInsert;
